// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"182":"component---src-pages-imprint-tsx","218":"component---src-pages-404-tsx","330":"component---src-pages-band-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"182":"b2f68656d13b7ac490c0","218":"e6480b69f7f3aa4ea983","330":"ef68cf93ba55f14d5444","691":"7f6addb1b34c0674d325"}[chunkId] + ".js";
};